(function () {
  'use strict';
  var header = document.querySelector('[data-caw-header]');
  var updateBasket = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) { return response.ok ? response.json() : null; }).then(function (cart) {
      if (!cart || !header) return;
      var count = String(cart.item_count || 0);
      header.querySelectorAll('.caw-cart-count').forEach(function (badge) { badge.textContent = count; badge.hidden = Number(count) === 0; });
      var desktopLink = header.querySelector('.caw-header__tools .caw-header__tool[href="/cart"] span');
      if (desktopLink) desktopLink.textContent = Number(count) ? 'Basket (' + count + ')' : 'Basket';
      var basket = header.querySelector('.caw-header__tools .caw-header__tool[href="/cart"], .caw-header__mobile-tools .caw-icon-button[href="/cart"]');
      if (basket) {
        basket.classList.remove('caw-cart-updated');
        void basket.offsetWidth;
        basket.classList.add('caw-cart-updated');
        window.setTimeout(function () { basket.classList.remove('caw-cart-updated'); }, 850);
      }
    }).catch(function () {});
  };
  document.addEventListener('caw:cart-updated', function () {
    updateBasket();
    window.setTimeout(function () { window.location.href = '/cart'; }, 160);
  });
})();

